"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schedulingStrategies = void 0;
var schedulingStrategies;
(function (schedulingStrategies) {
    schedulingStrategies["FIRST_AVAILABLE_SLOT"] = "firstAvailableSlot";
    schedulingStrategies["RANDOM_IN_TIME_RANGE"] = "randomInTimeRange";
    schedulingStrategies["TRIGGER_NOW"] = "triggerNow";
    schedulingStrategies["TRIGGER_EXACTLY_AFTER_DELAY"] = "triggerExactlyAfterDelay";
    schedulingStrategies["EARLIEST_IN_TIME_RANGE"] = "earliestInTimeRange";
    schedulingStrategies["TRIGGER_EXACTLY_BEFORE_DELAY"] = "triggerExactlyBeforeDelay";
})(schedulingStrategies || (exports.schedulingStrategies = schedulingStrategies = {}));
